import React, { FunctionComponent } from 'react';

import { AppColors } from '../../styles';
import Image from '../../components/Image';
import images from '../images';

interface Props {
  color?: AppColors;
  width?: number;
  height?: number;
  className?: string;
}

const Twitter: FunctionComponent<Props> = (
  {
    color = 'black',
    width = 12,
    height = 12,
    className = '',
  }: Props,
) => (
  <Image src={images.social.twitter} className={`w-${width} h-${height} text-${color} fill-current ${className}`} />
);

export default Twitter;
